/**
 * Regalo de preventa: añade solo al carrito el regalo que lleva cada agenda.
 *
 * Qué regalo lleva cada producto se configura en el admin, en el metafield
 * «Regalo» (custom.regalo) del producto. El regalo es otro producto a RD$0,
 * oculto del catálogo, así que no hace falta ningún descuento.
 *
 * Va un regalo por cada unidad del producto que lo trae: si se quitan
 * agendas, se quitan regalos; si el regalo se agota, deja de añadirse. La
 * línea del regalo lleva la propiedad oculta _regalo, que el carrito usa para
 * enseñarla como «Regalo» y sin selector de cantidad.
 *
 * El año pasado esto falló con el carrito lateral. Aquí el script escucha el
 * mismo evento que usa Dawn (PUB_SUB_EVENTS.cartUpdate) y, cuando cambia algo,
 * vuelve a publicarlo para que el carrito lateral y la página se repinten.
 */
(function () {
  var ORIGEN = 'regalos-preventa';
  var corriendo = false;
  var pendiente = false;

  function leerCarrito() {
    return fetch(window.Shopify.routes.root + 'cart?section_id=regalos-carrito')
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var datos = doc.querySelector('[data-regalos-carrito]');
        return datos ? JSON.parse(datos.textContent) : [];
      });
  }

  function postJson(ruta, cuerpo) {
    return fetch(window.Shopify.routes.root + ruta, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(cuerpo),
    }).then(function (r) {
      return r.ok;
    });
  }

  /* Compara lo que hay con lo que debería haber y devuelve si cambió algo. */
  function ajustar(lineas) {
    var debidos = {};
    lineas.forEach(function (l) {
      if (!l.esRegalo && l.regalo) debidos[l.regalo] = (debidos[l.regalo] || 0) + l.cantidad;
    });

    // Las líneas de regalo que ya están: la primera de cada variante se lleva
    // la cantidad debida; las repetidas, a cero.
    var cambios = {};
    var vistos = {};
    lineas.forEach(function (l) {
      if (!l.esRegalo) return;
      var objetivo = vistos[l.variante] ? 0 : debidos[l.variante] || 0;
      vistos[l.variante] = true;
      if (objetivo !== l.cantidad) cambios[l.key] = objetivo;
    });

    var nuevos = Object.keys(debidos)
      .filter(function (v) {
        return !vistos[v];
      })
      .map(function (v) {
        return { id: Number(v), quantity: debidos[v], properties: { _regalo: 'preventa' } };
      });

    var pasos = [];
    if (Object.keys(cambios).length) pasos.push(postJson('cart/update.js', { updates: cambios }));
    if (nuevos.length) pasos.push(postJson('cart/add.js', { items: nuevos }));
    return Promise.all(pasos).then(function (res) {
      return res.some(Boolean);
    });
  }

  function repintar() {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: ORIGEN });
    }
    // El contador del ícono del carrito no escucha el evento.
    fetch(window.Shopify.routes.root + '?section_id=cart-icon-bubble')
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var burbuja = document.getElementById('cart-icon-bubble');
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nueva = doc.querySelector('.shopify-section');
        if (burbuja && nueva) burbuja.innerHTML = nueva.innerHTML;
      })
      .catch(function () {});
  }

  function sincronizar() {
    if (corriendo) {
      pendiente = true;
      return;
    }
    corriendo = true;
    leerCarrito()
      .then(ajustar)
      .then(function (cambio) {
        if (cambio) repintar();
      })
      .catch(function (e) {
        console.error('Regalos de preventa:', e);
      })
      .finally(function () {
        corriendo = false;
        if (pendiente) {
          pendiente = false;
          sincronizar();
        }
      });
  }

  function iniciar() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (evento) {
        if (!evento || evento.source !== ORIGEN) sincronizar();
      });
    }
    // Al cargar la página solo hace falta mirar si el carrito tiene algo: Dawn
    // pinta la burbuja del contador únicamente cuando no está vacío.
    if (document.querySelector('#cart-icon-bubble .cart-count-bubble')) sincronizar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
